import { useEffect, useState } from 'react';
import { getUiMode, isDarkActive, setUiMode, type UiMode } from '../utils/theme';

/** Aktuální režim (světlý / tmavý / podle systému) a přepínání – osobní nastavení v tomto prohlížeči. */
export function useUiMode() {
  const [mode, setMode] = useState<UiMode>(() => getUiMode());
  const [dark, setDark] = useState<boolean>(() => isDarkActive());
  useEffect(() => {
    const h = () => { setMode(getUiMode()); setDark(isDarkActive()); };
    window.addEventListener('ui-mode-change', h);
    return () => window.removeEventListener('ui-mode-change', h);
  }, []);
  return { mode, dark, setMode: setUiMode, toggle: () => setUiMode(dark ? 'light' : 'dark') };
}
